import { selectWeek } from 'logic/product';
import { setRedirect } from 'logic/redirect';

import {
  fetchMealPlanSwaps,
  resetMealPlan,
  selectDays,
  selectHasSwaps,
  selectMealPlan,
  selectMealPlanPdfs,
  selectMealsHasCookup,
  swapMeal,
  swapRemove,
  swapRevert,
} from 'logic/mealPlan';

import {
  selectMember,
  selectMemberLevel,
  selectSubscription,
  selectIsProductLowFodmap,
} from 'logic/member';

export const MealPlanBasic = {
  template: `
    <div class="meal-plan meal-plan--swap">
      <main class="main-content border border-y bg-gray-100 pt-3 pb-5">
        <div class="container mb-3">
          <div class="row">
            <div class="col-12 mx-auto" ng-hide="$ctrl.isLoading">
              <div class="meal-plan-meta">
                <div class="d-flex align-item-center mb-3"
                  ng-class="{
                    'justify-content-between': $ctrl.mealPlan.hasSwaps,
                    'justify-content-end': !$ctrl.mealPlan.hasSwaps
                  }">
                  <button-link ng-click="$ctrl.resetMealPlan($ctrl.mealPlan.id)"
                    ng-show="$ctrl.mealPlan.hasSwaps">
                    Reset Meal Plan
                  </button-link>
                  <meal-plan-print
                    pdfs="$ctrl.pdfs"
                    level="$ctrl.level">
                  </meal-plan-print>
                </div>
                <div class="mb-3" ng-show="$ctrl.hasCookup">
                  <meal-plan-cook-more></meal-plan-cook-more>
                </div>
              </div>
              <div class="d-md-flex mb-4"
                ng-class="{ swapping: $ctrl.isSwapping }"
                ng-repeat="day in $ctrl.days track by $index">
                <div class="meal-plan-day pr-md-4 text-center">
                  <meal-plan-day-icon
                    is-swapping="$ctrl.isSwapping"
                    count="day.meals.length">
                    <span ng-show="$ctrl.week">
                      Day {{ $index + 1 }}
                    </span>
                  </meal-plan-day-icon>
                  <small class="meal-plan-day-cals d-block text-teal-dark font-weight-semibold mt-md-1">
                    {{ day.calories }} Cal
                  </small>
                </div>
                <div class="meal-plan-recipes">
                  <div class="bg-white"
                    ng-repeat="meal in day.meals track by $index">
                    <meal-plan-recipe-swap
                      meal="meal"
                      voome-product-id="$ctrl.voomeProductId"
                      is-product-low-fodmap="$ctrl.isProductLowFodmap"
                      on-swap="$ctrl.swapMeal(mealPlanRecipeId, recipeContainerId)"
                      on-remove="$ctrl.swapRemove(meal.id)"
                      on-revert="$ctrl.swapRevert(meal.swappedMealId)"
                      on-preview="$ctrl.onPreview(recipe)"
                      on-learn-more="$ctrl.onLearnMore()">
                    </meal-plan-recipe-swap>
                  </div>
                  <div class="bg-white h-100 d-flex justify-content-center align-items-center"
                    ng-show="day.meals.length === 0">
                    <strong>
                      No meals added for day {{ $index + 1 }}
                    </strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <recipe-preview
          recipe-id="$ctrl.recipePreviewId"
          show-on="$ctrl.recipePreviewShow">
        </recipe-preview>
      </main>
    </div>`,

  controller($ngRedux, $location, $timeout) {
    'ngInject';

    return {
      $onInit() {
        const connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        if (!this.mealPlan.id) {
          this.fetchMealPlanSwaps(this.mealPlanId, this.memberId, this.level);
        }
      },

      $onDestroy() {
        this.disconnect();
      },

      onPreview(recipe) {
        this.recipePreviewId = recipe.id;
        this.recipePreviewShow = true;
        $timeout(() => (this.recipePreviewShow = false));
      },

      onLearnMore() {
        this.setRedirect({ path: $location.path() });
      },

      mapState({ mealPlan, member, product, router }) {
        const { mealPlanId, voomeProductId, weekNumber } = router.currentParams;
        const { isLoading, isSwapping } = mealPlan;
        const subscription = selectSubscription(member);

        return {
          mealPlanId,
          subscription,
          voomeProductId,
          days: selectDays(mealPlan, mealPlanId),
          hasCookup: selectMealsHasCookup(mealPlan, mealPlanId),
          isLoading: isLoading && !isSwapping,
          isSwapping: isSwapping,
          level: selectMemberLevel(member),
          mealPlan: selectMealPlan(mealPlan, mealPlanId),
          memberId: selectMember(member).id,
          pdfs: selectMealPlanPdfs(mealPlan, mealPlanId, subscription.id),
          week: selectWeek(product, weekNumber),
          isProductLowFodmap: selectIsProductLowFodmap(member, voomeProductId),
        };
      },

      mapDispatch() {
        return {
          fetchMealPlanSwaps,
          resetMealPlan,
          swapRemove,
          swapRevert,
          swapMeal,
          setRedirect,
        };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/MealPlanBasic.js